<div class="w-full max-w-[1400px] items-center justify-between flex mx-auto">
  <a class="relative h-[32px] w-[100px]">
    <img src="/assets/img/branding/logo-full.svg" alt="" class="absolute w-full h-full object-contain">
  </a>
  <button pButton class="p-button-s p-button-secondary" (click)="scrollTop()">
    Наверх
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 15L12 7.5L19.5 15" stroke="#050A24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</div>
